import React from 'react';
import TableLink from '../../components/TableLink';

export const AGENCY_COLUMNS = [
  {
    Header: 'Company Name',
    accessor: 'name',
    Cell: ({ cell: { value: name }, row: { original } }) => {
      return (
        <TableLink to={`/administration/agency/${original.id}`}>
          {name}
        </TableLink>
      );
    },
  },
  {
    Header: '# of Clients',
    accessor: 'clientCount',
  },
  {
    Header: '# of Funders',
    accessor: 'funderCount',
  },
  {
    Header: '# of Projects',
    accessor: 'projectCount',
  },
  {
    Header: 'Membership Type',
    accessor: 'membership',
  },
];

export const AGENCY_FIELDS = [];
